import { useTranslation } from 'next-i18next/pages'
import ArticleSection from 'components/article/article-section/ArticleSection'
import styles from './EncyclopediaSubCategory.module.scss'
import Hero from 'features/encyclopedia/components/hero/Hero'
import EncyclopediaNav from 'features/encyclopedia/components/encyclopedia-nav/EncyclopediaNav'
import { EncyclopediaSubcategoryProps } from 'features/encyclopedia/sub-category/types'

const EncyclopediaSubCategory = ({ articles, subCategory }: EncyclopediaSubcategoryProps) => {
  // i18n
  const { t } = useTranslation(['encyclopedia'])

  return (
    <>
      {/* BREADCRUMBS + SEARCH */}
      <EncyclopediaNav />

      {/* HERO */}
      <Hero category={subCategory.category} subCategory={subCategory.title} />

      {/* ARTICLES */}
      <ArticleSection title={t('article', 'Artikels')} articles={articles} className={styles.articles} />
    </>
  )
}

export default EncyclopediaSubCategory
